const ALL = Symbol('*');
/**
 * Questa classe esegue uno switch tra possibili valori dei campi di un oggetto.
 */
class Switch {
    constructor() {
        this.switchCases = [];
        this.defaultAction = null;
    }
    /**
     * Definisce un caso dello switch.
     * @param switchCase Caso dello switch. Utilizzare il simbolo `ALL` permette di definire un caso che corrisponde a tutti i valori.
     * @param action Azione da eseguire se il caso è verificato. Se riturna false, non verranno eseguiti altri casi.
     * @returns this
     */
    case(switchCase, action) {
        this.switchCases.push({ switchCase, action });
        return this;
    }
    /**
     * Definisce un caso di default.
     * @param action Azione da eseguire se il caso è verificato. Se riturna false, non verranno eseguiti altri casi.
     * @returns this
     */
    default(action) {
        this.defaultAction = action;
        return this;
    }
    /**
     * Avvia lo switch e sceglie tra le opzioni in base al valore.
     * @param data valore.
     */
    switch(data) {
        const actions = this.switchCases
            .filter(({ switchCase }) => Switch.isSwitchCaseOf(switchCase, data))
            .map(({ action }) => action);
        for (let i = 0; i < actions.length; i++) {
            const action = actions[i];
            const result = action(data);
            if (typeof result !== 'boolean' || !result) {
                return;
            }
        }
        if (this.defaultAction !== null) {
            this.defaultAction(data);
        }
    }
    static isSwitchCaseOf(switchCase, data) {
        const entries = Object.entries(switchCase);
        for (let i = 0; i < entries.length; i++) {
            const [key, value] = entries[i];
            const fieldValue = data[key];
            if (value !== ALL && value !== fieldValue) {
                return false;
            }
        }
        return true;
    }
}
Switch.ALL = ALL;

export { ALL, Switch as default };
